/* eslint-disable no-unused-vars */
import { NodeApi } from "react-arborist";
import { TResursTreeNode } from "../../treeTypes";
import { FC, useEffect } from "react";
import { Button } from "primereact/button";
import styles from "./node-arrow.module.css";
import { openNode } from "../../../../services/slices/tree";
import { useAppDispatch } from "../../../../services/types/store-types";
export const isRootNode = (id: string) => {
  switch (id) {
    case "root":
      return true;
    case "r_overall":
      return true;
    case "r_proxy_msg":
      return true;
    case "r_asq":
      return true;
    case "integration":
      return true;
    default:
      return false;
  }
};

export const Arrow: FC<{
  node: NodeApi<TResursTreeNode>;
  handleClick: any;
}> = ({ node, handleClick }) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (node.isOpen && node.children!.length) {
      dispatch(openNode({ tree: node.data.tree, nodeId: node.data.id }));
    }
  }, [dispatch, node]);

  return (
    <Button
      icon={
        node.isOpen && node.children!.length > 0
          ? "pi pi-chevron-down"
          : "pi pi-chevron-right"
      }
      rounded
      text
      severity="secondary"
      aria-label="Cancel"
      className={styles.arrow}
      onClick={handleClick}
    />
  );
};
